import React, { Component } from 'react';
import Jumbotron from './Jumbotron';
import LatestUpdates from './LatestUpdates';
import Navbar from "../commons/Navbar";


export class Homepage extends Component {

  render() {
    return (
      <React.Fragment>
        <Navbar />

        <Jumbotron />
        <LatestUpdates />

      </React.Fragment>
    )
  }
}

export default Homepage
